import React from 'react';
import PropTypes from 'prop-types';
import AppFrame from './AppFrame';

class ToolFrame extends React.Component {
    render() {
        return (
            <div>
                <AppFrame
                    isInside={false}
                    currentContent={this.props.currentContent}
                    isTool={true}
                    notify={this.props.notify}
                >
                    <div className={'fe-contents-backend'} style={{ top: '45px' }}>
                        {React.createElement(this.props.toolComponent, Object.assign({}, this.props))}
                    </div>
                </AppFrame>
            </div>
        );
    }
}
ToolFrame.propTypes = {
    toolComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func
    ]).isRequired,
    currentContent: PropTypes.object,
    notify: PropTypes.func.isRequired,
};

export default ToolFrame;